const TOKEN_LIST = [
  {
    l1Address: "0x55d398326f99059fF775485246999027B3197955",
    l2Address: "0x9e5aac1ba1a2e6aed6b32689dfcf62a509ca96f3",
    tokenSymbol: "USDT",
    logo: "USDT.svg",
    decimalValue: 18,
  },
  {
    l1Address: "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
    l2Address: "0x7c6b91d9be155a6db01f749217d76ff02a7227f2",
    tokenSymbol: "BTCB",
    logo: "BTCB.svg",
    decimalValue: 18,
  },
  {
    l1Address: "0x02750CC334E96aeF8C8ad9b75f13F93EC2Aaeccd",
    l2Address: "0x02750CC334E96aeF8C8ad9b75f13F93EC2Aaeccd",
    tokenSymbol: "BONES",
    logo: "BONES.svg",
    decimalValue: 18,
  },
];

export default TOKEN_LIST;
